












































import { Component, Vue, Prop } from 'vue-property-decorator'
import SplitPane from 'vue-splitpane'
import { AppModule } from '@/store/modules/app'
import { PersionModule } from '@/store/modules/pension'
@Component({
  name: '',
  components: {
    SplitPane,
  },
})
export default class extends Vue {
  defaultPercent = 57
  @Prop() iframeSrc!: string;
  @Prop() iframeId!: string;

  loading = true;
   paneValue: number | null = null
   mounted () {
     AppModule.CloseSideBar(false)
     window.addEventListener('message', this.handleMessage);
     (document.getElementById(this.iframeId) as HTMLElement).onload = () => {
       this.loading = false
     }
   }

   created () {
     if (window.outerWidth < 1441) {
       this.defaultPercent = 52
     }
   }

   handleMessage (event: MessageEvent) {
     if (event && event.data && event.data.params) {
       const { path } = event.data.params
       // console.log('eee path', path)
       this.$router.push(path)
     }
     // console.log('eee', event)/
   }

   resize (value: number) {
     PersionModule.SET_PANEVALUE(value)
   }
}
